<template>
  <div :class="['payments__description', {'payments__description--status': status}]">
    <img v-if="status && gateway" class="payments__flag" :src="gateway.picture" alt="">

    <div>
      <ul v-if="!items.method">
        <li class="payments__text">Escolha um dos meios de pagamento.</li>
        <li class="payments__text" v-if="!checkout">Digite o valor que deseja inserir.</li>
        <li class="payments__text">Confira o tempo de processamento.</li>
        <li class="payments__text">Confirme o pagamento.</li>
      </ul>

      <div v-else-if="items.method === 'wallet'">
        <p class="payments__text">{{items.message.alert}}</p>
      </div>

      <div v-else>
        <div class="payments__text" v-for="item in items.message" :key="item.title">
          <span class="payments__title">{{item.title}} </span>{{item.text}}
        </div>
        <p class="payments__alert" v-if="items.span">
          {{items.span.text}}
          <a class="payments__link" :href="this.$sanitizeUrl(items.span.link.url)" target="__BLANK" rel="noopener noreferrer">{{items.span.link.label}}</a>
        </p>
      </div>
    </div>

    <div class="payments__description--slot" v-if="!status">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentDescription',

  props: {
    method: String,
    status: Boolean,
    checkout: Boolean,
    gateway: Object,
  },

  data () {
    return  {
      methodName: '',
      items: [],
      messages: [
        {
          method: 'wallet',
          message: {
            alert: 'Os pagamentos de etiquetas utilizando o saldo em sua Melhor Carteira tem aprovação instantânea.'
          }
        },
        {
          method: 'picpay',
          message: [
            {
              title: 'Saldo em conta:',
              text: 'geralmente aprovação instantânea, mas pode levar até 48h úteis. '
            },
            {
              title: 'Cartão de crédito:',
              text: 'geralmente aprovação em poucos minutos, mas pode levar até 48h úteis.'
            }
          ]
        },
        {
          method: 'paypal',
          message: [
            {
              title: 'Saldo em conta:',
              text: 'geralmente aprovação instantânea, mas pode levar até 48h úteis.'
            },
            {
              title: 'Cartão de crédito:',
              text: 'geralmente aprovação em poucos minutos, mas pode levar até 48h úteis.'
            }
          ]
        },
        {
          method: 'mercado-pago',
          message: [
            {
              title: 'Saldo em conta:',
              text: 'geralmente aprovação instantânea, mas pode levar até 48h úteis.'
            },
            {
              title: 'Cartão de crédito:',
              text: 'geralmente aprovação em poucos minutos, mas pode levar até 48h úteis.'
            },
            {
              title: 'Lotérica:',
              text: 'aprovação em até 1h.'
            },
            {
              title: 'Boleto:',
              text: 'aprovação pode levar de 1 a 2 dias úteis.'
            },
            {
              title: 'PIX:',
              text: 'instantânea na maioria das vezes, mas pode levar até 2h úteis.'
            },
          ]
        },
        {
          method: 'pagseguro',
          message: [
            {
              title: 'Saldo em conta:',
              text: 'geralmente aprovação instantânea, mas pode levar até 48h úteis.'
            },
            {
              title: 'Cartão de crédito:',
              text: 'geralmente aprovação em poucos minutos, mas pode levar até 48h úteis.'
            }
          ]
        },
        {
          method: 'moip',
          span: {
            text: '',
            link: {
              label: '',
              url: ''
            }
          },
          message: [
            {
              title: 'Débito em conta:',
              text: 'aprovação em até 24h.'
            },
            {
              title: 'Cartão de crédito:',
              text: 'aprovação em até 48h.'
            },
            {
              title: 'Cartão de débito:',
              text: 'aprovação em até 48h.'
            },
            {
              title: 'Saldo Wirecard*:',
              text: 'geralmente aprovação instantânea, mas pode levar até 48h úteis.'
            },
          ]
        },
        {
          method: 'yapay',
          message: [
            {
              title: 'Saldo em conta:',
              text: 'aprovação geralmente instantânea, mas pode levar até 48h úteis.'
            },
            {
              title: 'Cartão de crédito:',
              text: 'aprovação geralmente em poucos minutos, mas pode levar até 48h úteis.'
            },
            {
              title: 'Transferência online:',
              text: 'a aprovação pode apresentar prazo de processamento de até 4h úteis.'
            },
            {
              title: 'Boleto Bancário:',
              text: 'a aprovação do pagamento pode apresentar prazo de processamento de até 48h úteis.'
            }
          ]
        },
        {
          method: 'yapay-transparente',
          message: [
            {
              title: 'Cartão de crédito:',
              text: 'a aprovação costuma ocorrer em poucas horas. Em casos raros, a análise pode levar até 48h úteis.'
            },
            {
              title: 'Boleto Bancário:',
              text: 'a aprovação pode levar até 48h úteis.'
            }
          ]
        }
      ]
    };
  },

  watch: {
    method(value) {
      if(value) {
        this.items = this.messages.filter((obj) => obj.method === value)[0];
      }

      return;
    }
  },

  mounted() {
    this.methodName = this.$store.getters['getSelectedMethod'];
    this.checkoutText(this.methodName);
  },

  methods: {
    checkoutText(slug) {
      if(slug) {
        this.items = this.messages.filter((obj) => obj.method === slug)[0];
      }

      return;
    }
  }
};
</script>
